import login from "./views/LoginV2";
import Addresses from "./views/addresses/Addresses";
import AddressCreate from "./views/addresses/AddressCreate";
import AddressUpdate from "./views/addresses/AddressUpdate";
import Services from "./views/services/Services";
import ServicesCliente from "./views/services/ServicesCliente";
import ServicesCreate from "./views/services/ServiceCreate";
import ServicesUpdate from "./views/services/ServiceUpdate";
import Documentos from "./views/Documentos";
import ExpedicionRapida from "./views/ExpedicionRapida";
import Admin from "./views/Admin";

export default [
  {
    path: "/",
    redirect: "/login"
  },
  {
    path: "/login",
    name: "login",
    component: login
  },
  {
    path: "/direcciones",
    name: "addresses",
    component: Addresses,
    meta: { requiresAuth: true }
  },
  {
    path: "/direcciones/create",
    name: "address-create",
    component: AddressCreate,
    meta: { requiresAuth: true }
  },
  {
    path: "/direcciones/:id/update",
    name: "address-update",
    component: AddressUpdate,
    meta: { requiresAuth: true }
  },
  {
    path: "/servicioscliente",
    name: "servicescliente",
    component: ServicesCliente,
    meta: { requiresAuth: true }
  },
  {
    path: "/servicios",
    name: "services",
    component: Services,
    meta: { requiresAuth: true }
  },
  {
    path: "/servicios/create",
    name: "service-create",
    component: ServicesCreate,
    meta: { requiresAuth: true }
  },
  {
    path: "/servicios/:id/update",
    name: "service-update",
    component: ServicesUpdate,
    meta: { requiresAuth: true }
  },
  {
    path: "/documentos",
    name: "documentos",
    component: Documentos,
    meta: { requiresAuth: true }
  },
  {
    path: "/expedicionRapida",
    name: "expedicionRapida",
    component: ExpedicionRapida,
    meta: { requiresAuth: true }
  },
  {
    path: "/admin",
    name: "admin",
    component: Admin,
    meta: { requiresAuth: true }
  },
];
